function Content(props) {
  return (
    <div className="container-fluid mt-2 mb-4 p-3">
      {props.children}
    </div>
  );
}

export default Content;
